var map = {
	"../pages/adb-landing/adb-landing.module": [
		800,
		57
	],
	"../pages/chat-input-image-preview/chat-input-image-preview.module": [
		801,
		77
	],
	"../pages/common/about-us/about-us.module": [
		802,
		76
	],
	"../pages/common/account-settings-delete/account-settings-delete.module": [
		803,
		56
	],
	"../pages/common/account-settings/account-settings.module": [
		805,
		55
	],
	"../pages/common/attach-ticket/attach-ticket.module": [
		804,
		54
	],
	"../pages/common/bank-in/bank-in.module": [
		808,
		53
	],
	"../pages/common/cashout/cashout.module": [
		806,
		52
	],
	"../pages/common/credit-card-type/credit-card-type.module": [
		807,
		51
	],
	"../pages/common/credit-card/credit-card.module": [
		809,
		50
	],
	"../pages/common/faq/faq.module": [
		810,
		49
	],
	"../pages/common/forgot-password/forgot-password.module": [
		811,
		75
	],
	"../pages/common/grid-menu/grid-menu.module": [
		812,
		21
	],
	"../pages/common/guest-reg/guest-reg.module": [
		815,
		74
	],
	"../pages/common/in-app-purchase/in-app-purchase.module": [
		813,
		48
	],
	"../pages/common/inbox/inbox.module": [
		814,
		73
	],
	"../pages/common/input-referral-code/input-referral-code.module": [
		816,
		47
	],
	"../pages/common/member-reg-details/member-reg-details.module": [
		821,
		72
	],
	"../pages/common/member-reg/member-reg.module": [
		818,
		71
	],
	"../pages/common/notification-settings/notification-settings.module": [
		817,
		46
	],
	"../pages/common/privacy-tc/privacy-tc.module": [
		819,
		45
	],
	"../pages/common/share/share.module": [
		822,
		44
	],
	"../pages/common/shop-menu/shop-menu.module": [
		820,
		32
	],
	"../pages/common/start-up/start-up.module": [
		823,
		24
	],
	"../pages/common/terms-n-conditions/terms-n-conditions.module": [
		825,
		70
	],
	"../pages/common/union-pay/union-pay.module": [
		824,
		34
	],
	"../pages/common/update-app/update-app.module": [
		826,
		69
	],
	"../pages/common/verify-tipster/verify-tipster.module": [
		827,
		43
	],
	"../pages/common/wallet/wallet.module": [
		828,
		68
	],
	"../pages/create-fb-tips-details/create-fb-tips-details.module": [
		829,
		28
	],
	"../pages/create-fb-tips/create-fb-tips.module": [
		834,
		33
	],
	"../pages/fb-match-discussion/fb-match-discussion.module": [
		830,
		19
	],
	"../pages/football-settings/football-settings.module": [
		831,
		67
	],
	"../pages/football-tips-list/fb-tips-details/fb-tips-details.module": [
		832,
		27
	],
	"../pages/football-tips-list/fb-tips-list.module": [
		833,
		2
	],
	"../pages/home/home.module": [
		835,
		12
	],
	"../pages/horse-article/horse-article.module": [
		838,
		22
	],
	"../pages/horse/create-tips-package-notes/create-tips-package-notes.module": [
		836,
		66
	],
	"../pages/horse/horse-create-in-race-tips/horse-create-in-race-tips.module": [
		840,
		26
	],
	"../pages/horse/horse-create-tips-package-select-horse/horse-create-tips-package-select-horse.module": [
		837,
		65
	],
	"../pages/horse/horse-create-tips-package/horse-create-tips-package.module": [
		839,
		6
	],
	"../pages/horse/horse-edit-racing-note/horse-edit-racing-note.module": [
		841,
		42
	],
	"../pages/horse/horse-follow-list/horse-follow-list.module": [
		842,
		18
	],
	"../pages/horse/horse-home-discussion/horse-home-discussion.module": [
		845,
		10
	],
	"../pages/horse/horse-home-list-tips/horse-home-list-tips.module": [
		844,
		0
	],
	"../pages/horse/horse-home-racing-notes/horse-home-racing-notes.module": [
		843,
		30
	],
	"../pages/horse/horse-in-race-tips-details/horse-in-race-tips-details.module": [
		847,
		8
	],
	"../pages/horse/horse-list-racing-notes/horse-list-racing-notes.module": [
		846,
		41
	],
	"../pages/horse/horse-price-settings/horse-price-settings.module": [
		848,
		40
	],
	"../pages/horse/horse-settings/horse-settings.module": [
		850,
		64
	],
	"../pages/horse/horse-tab/horse-tab.module": [
		849,
		58
	],
	"../pages/horse/horse-tips-package-details/horse-tips-package-details.module": [
		852,
		7
	],
	"../pages/horse/horse-tipster-info/horse-tipster-info.module": [
		851,
		25
	],
	"../pages/horse/ranking/horse-in-race-tips-ranking/horse-in-race-tips-ranking.module": [
		853,
		17
	],
	"../pages/horse/ranking/horse-ranking/horse-ranking.module": [
		854,
		16
	],
	"../pages/horse/ranking/horse-tips-package-ranking/horse-tips-package-ranking.module": [
		855,
		15
	],
	"../pages/image-modal/image-modal.module": [
		207
	],
	"../pages/kinboy-member-reg/kinboy-member-reg.module": [
		856,
		23
	],
	"../pages/kinboy-promotion/kinboy-promotion.module": [
		857,
		39
	],
	"../pages/leader-board/leader-board.module": [
		858,
		14
	],
	"../pages/list-fb-tips-package/list-fb-tips-package.module": [
		859,
		63
	],
	"../pages/login/login.module": [
		368
	],
	"../pages/match-details/match-details.module": [
		860,
		62
	],
	"../pages/match/match.module": [
		861,
		29
	],
	"../pages/menu/activity/activity.module": [
		862,
		38
	],
	"../pages/menu/help/help.module": [
		864,
		11
	],
	"../pages/menu/lang/lang.module": [
		863,
		37
	],
	"../pages/menu/menu.module": [
		369
	],
	"../pages/menu/price-settings/price-settings.module": [
		865,
		36
	],
	"../pages/menu/shop/shop.module": [
		866,
		35
	],
	"../pages/menu/transaction/transaction.module": [
		867,
		31
	],
	"../pages/package/fb-tips-package-discussion/fb-tips-package-discussion.module": [
		870,
		9
	],
	"../pages/package/fb-tips-package-pop-over/fb-tips-package-pop-over.module": [
		868,
		61
	],
	"../pages/package/package.module": [
		869,
		4
	],
	"../pages/package/show-tips-package-details/show-tips-package-details.module": [
		871,
		5
	],
	"../pages/pro-analysis/pro-analysis.module": [
		873,
		13
	],
	"../pages/show-fb-tips-package/show-fb-tips-package.module": [
		872,
		1
	],
	"../pages/show-tipster-analysis/show-tipster-analysis.module": [
		874,
		20
	],
	"../pages/tab/tab.module": [
		876,
		60
	],
	"../pages/tipster-info/tipster-info.module": [
		875,
		3
	],
	"../pages/tutorial-modal/tutorial-modal.module": [
		877,
		59
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 252;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy
// module id = 252
// module chunks = 78